import { Button, Form, Input, Typography, message } from 'antd';
import LocaleContext from 'locales';
import React, { useContext, useEffect } from 'react';
import { localeKeyToString } from 'pages/utils';
import { getApprovalComments, saveApprovalComment } from 'services/websocket/approval';
import ConfigContext from 'store/ConfigContext';
/**
 * 서비스 신청 코멘트 컴포넌트
 * ? 관리자/결재자는 누구나 1개의 textarea 업데이트가 가능함
 * @returns {JSX.Element}
 */
export default function Comment({ id, isApproval, isCompleted, form, setIsSaveComment }) {
  const { locale } = useContext(LocaleContext);
  const config = useContext(ConfigContext);

  useEffect(() => {
    if (!id) {
      return;
    }
    getApprovalComments(id).then((res) => {
      if (res) {
        form.setFieldsValue({ comments: res.comments });
        if (res.comments?.length > 0) {
          setIsSaveComment(true);
        }
      } else {
        form.setFieldsValue({ comments: '' });
      }
    });
  }, [id]);

  return (
    <>
      <Typography.Title level={5}>{locale.resource['approval.field.comment']}</Typography.Title>
      <Form
        form={form}
        layout="horizontal"
        onFinish={async (values) => {
          const payload = values?.comments || '';
          // 코멘트 값이 없는 경우 빈 문자열로 처리

          const res = await saveApprovalComment(id, payload);

          if (!res.success) {
            form.setFields(res.error);
            message.error(res.error);
          } else {
            setIsSaveComment(true);
            return message.success(locale.resource['approval.commnet.save.success.message']);
          }
          return res.data;
        }}
      >
        <Form.Item
          name="comments"
          rules={[
            {
              required: config.siteName === 'lgensol-usa',
              message: locale.resource['txt.required-field'],
            },
            {
              type: 'string',
              max: 999,
              validator: async (rule, value) => {
                if (value !== undefined && value.length > rule.max) {
                  return Promise.reject(
                    new Error(
                      localeKeyToString({
                        key: 'validation.approval-request.reason-too-long',
                        values: { 0: rule.max + 1 },
                      }),
                    ),
                  );
                }
                return Promise.resolve();
              },
            },
          ]}
        >
          <Input.TextArea
            readOnly={!isApproval || isCompleted}
            showCount
            rows={4}
            placeholder={locale.resource['common.input.placeholder']}
          />
        </Form.Item>
        <Button disabled={!isApproval || isCompleted} onClick={form.submit}>
          {locale.resource['approval.commnet.save']}
        </Button>
      </Form>
    </>
  );
}
